import { jsxs, jsx } from 'react/jsx-runtime';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { useRouter } from '@fabric-app/compat';
import { styled } from 'styled-components';
import { useQueryResourceAssets } from '../../queries/useQueryResourceAssets.js';
import { Flex } from '@fabric-app/ui/components/Flex';
import { Button } from '@fabric-app/ui/components/Button';
import { IconLinkArrow } from '@fabric-app/icons/svg';
import { LinkExternal } from '@fabric-app/ui/components/Link/LinkExternal';
import { SPAN } from '@fabric-app/ui/components/Typography';

const NotionFooterBase = styled.div.withConfig({
  displayName: "NotionFooter__NotionFooterBase",
  componentId: "sc-67ce4a72-0"
})([
  `flex-shrink:0;border-top:1px solid `,
  `;display:flex;align-items:center;justify-content:space-between;padding:0 16px;height:60px;`
], cssVar["color-border-primary"]);
const NotionFooter = ({ resource }) => {
  const router = useRouter();
  const queryAssets = useQueryResourceAssets({
    resource
  });
  return /* @__PURE__ */ jsxs(NotionFooterBase, {
    children: [
      /* @__PURE__ */ jsxs(Flex, {
        gap: "elementsContainer",
        children: [
          (queryAssets.data?.data.assets.length || 0) > 0 && /* @__PURE__ */ jsx(Button, {
            variant: "bg-secondary",
            size: "xs",
            onClick: () => {
              router.replace({
                query: {
                  ...router.query,
                  showAssetsPanel: "true"
                }
              });
            },
            children: "Show all sub-pages"
          }),
          /* @__PURE__ */ jsxs(Button, {
            variant: "bg-secondary",
            size: "xs",
            as: LinkExternal,
            href: resource.originUrl,
            children: [
              "Open original in Notion ",
              /* @__PURE__ */ jsx(IconLinkArrow, {
                style: {
                  fontSize: 10
                }
              })
            ]
          })
        ]
      }),
      /* @__PURE__ */ jsx(SPAN, {
        size: "md",
        children: "This is a read-only item."
      })
    ]
  });
};

export { NotionFooter };
//# sourceMappingURL=NotionFooter.js.map
